import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { BaseService } from '@common-modules/shared/base.service';
import { DialogService } from '@common-modules/shared/dialogs/dialogs.service';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CtInitialUserService extends BaseService {
  private _entityUrl: string;

  constructor(
    injector: Injector,
    private readonly _dialogService: DialogService,
    private readonly _router: Router,
  ) {
    super(injector);
    this._entityUrl = `${this.apiUrl}/integration/user`;
  }

  /**
   * Ensure that an integrator user exists in the DB and, if it was just created, set integration mode.
   */
  ensureIntegrationSetup(continueCallback: () => void): void {
    this.getIfUserExists().subscribe({
      next: (exists) => {
        if (exists) {
          continueCallback();
        } else {
          this.create().subscribe({
            next: (created) => {
              this.navigateToHome().subscribe({
                next: () => continueCallback(),
                error: (e) => this.onAnyError(e, continueCallback),
              });
            },
            error: (e) => this.onAnyError(e, continueCallback),
          });
        }
      },
      error: (e) => this.onAnyError(e, continueCallback),
    });
  }

  private create(): Observable<boolean> {
    return this.httpCacheClient.post<boolean>(this._entityUrl, {});
  }

  private getIfUserExists(): Observable<boolean> {
    return this.httpCacheClient.get<boolean>(this._entityUrl);
  }

  private navigateToHome(): Observable<void> {
    this._router.navigate(['']);
    return of(null);
  }

  private onAnyError = (error, continueCallback) => {
    this._dialogService.showErrorMessage(error);
    continueCallback();
  };
}
